<script setup>
import { ORIENTATION } from './constants';

const props = defineProps({
  reactions: { type: Array, default: () => [] },
  orientation: { type: String, default: ORIENTATION.LEFT },
});
</script>

<template>
  <div
    class="flex gap-1 flex-wrap -mt-2 px-2 z-10 relative"
    :class="
      props.orientation === ORIENTATION.RIGHT ? 'justify-end' : 'justify-start'
    "
  >
    <div
      v-for="reaction in props.reactions"
      :key="reaction.emoji"
      class="flex items-center bg-n-background dark:bg-n-slate-3 border border-n-slate-6 rounded-full px-2 py-0.5 text-sm shadow-sm select-none cursor-default"
    >
      <span>{{ reaction.emoji }}</span>
      <span
        v-if="reaction.count > 1"
        class="text-n-slate-11 text-xs font-medium ml-1"
      >{{ reaction.count }}</span>
    </div>
  </div>
</template>
